import LocationBlockedContent, { MAX_LOCATION_ATTEMPTS } from './LocationBlockedContent';
export default LocationBlockedContent;
export { MAX_LOCATION_ATTEMPTS };
